// extracted by mini-css-extract-plugin
export default {"promo-host__container":"styles_promo-host__container__6ffIR"};